import { NgModule } from '@angular/core';
import { ShareModule } from "../share/share.module";
import { RouterModule } from '@angular/router';

//component root
import { KeyInPasscodeComponent } from "./key-in-passcode.component";
//routes
import { KeyInPasscodeRoutes as routes } from "./key-in-passcode.routes";

@NgModule({
  declarations: [KeyInPasscodeComponent],
  exports:[
    KeyInPasscodeComponent
  ],
  imports: [
    ShareModule,
    RouterModule.forChild(routes),
  ]
})
export class KeyInPasscodeModule { }
